import {
  BLOGS_PAGE_LOADER,
  BLOGS_PAGE_SUCCESS,
  BLOGS_PAGE_FAILURE,
  BLOGS_PAGE_RESET,
} from "../../constants/Blog/BlogsConstants";

const initialState = {
  isLoading: false,
  BlogsData: [],
  errorMessage: "",
};

export const BlogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BLOGS_PAGE_LOADER:
      return { ...state, isLoading: true };

    case BLOGS_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        BlogsData: action.payload,
        errorMessage: "",
      };

    case BLOGS_PAGE_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error,
      };

    case BLOGS_PAGE_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
